import { render, staticRenderFns } from "./CourseInfoTab.vue?vue&type=template&id=0cca2742&scoped=true&"
import script from "./CourseInfoTab.vue?vue&type=script&lang=js&"
export * from "./CourseInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoTab.vue?vue&type=style&index=0&id=0cca2742&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca2742",
  null
  
)

export default component.exports